export const ORG_SHORT_NAME = window.ENV_ORG_SHORT_NAME;
export const ORG_LOGO = window.ENV_ORG_LOGO;
export const ORG_LOGOS_BY_LANG = JSON.parse(window.ENV_ORG_LOGOS_BY_LANG);
// export const ORG_SHORT_NAME = process.env.REACT_APP_ORG_SHORT_NAME;
// export const ORG_LOGO = process.env.REACT_APP_ORG_LOGO;
// export const ORG_LOGOS_BY_LANG = process.env.REACT_APP_ORG_LOGOS_BY_LANG;

export const APP_TITLE = `${ORG_SHORT_NAME} Digital Certificate of Entitlement`;
